export default {
    
    getPageUrl(){   
        var str = window.location.href;
        var partsOfStr = str.split('?'); 
        var site = partsOfStr[0];
        return site.replace(/\/?\#?$/, "");
    },
    validEmail(email) {
      var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      return re.test(email);
    },
    splitString(str,delimeter){
        var strArr = str.split(delimeter);
        var newStr ='';
        for(var i = 0; i < strArr.length; i++){
            newStr += strArr[i];
        }
        return newStr;
    },
    setCookie(cname, cvalue, exhours) {
        var d = new Date();
        d.setTime(d.getTime() + (exhours*60*60*1000));
        var expires = "expires="+ d.toUTCString();
        document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
    },
    getCookie(cname) {
        var name = cname + "=";
        var ca = document.cookie.split(';');
        for(var i = 0; i < ca.length; i++) {
            var c = ca[i];
            while (c.charAt(0) == ' ') {
                c = c.substring(1);
            }
            if (c.indexOf(name) == 0) {
                return c.substring(name.length, c.length);
            }
        }
        return "";
    },
    string_to_slug(str) {
        str = str.replace(/^\s+|\s+$/g, ''); // trim
        str = str.toLowerCase();
      
        // remove accents, swap ñ for n, etc
        var from = "àáäâèéëêìíïîòóöôùúüûñç·/_,:;";
        var to   = "aaaaeeeeiiiioooouuuunc------";
        for (var i=0, l=from.length ; i<l ; i++) {
            str = str.replace(new RegExp(from.charAt(i), 'g'), to.charAt(i));
        }

        str = str.replace(/[^a-z0-9 -]/g, '') // remove invalid chars
            .replace(/\s+/g, '_') // collapse whitespace and replace by -
            .replace(/-+/g, '_'); // collapse dashes

        return str;
    },
    handleResponse(response) {
        //console.log(response);
        const status = (response.body.status_code)? response.body.status_code : response.status;
        const isSuccessful = (status == 200 || status == 201)? true : false;
        const data = (isSuccessful)? response.body: false;
        const message = (response.body.message)
            ? response.body.message
            : false;

        return {status, message, isSuccessful, data };

    },
    store(key,value){ 
        window.localStorage.setItem(key,JSON.stringify(value));
    },
    retrive(key){
      return JSON.parse(window.localStorage.getItem(key));
    },
}